export default __webpack_public_path__ + "static/media/img1.0edcc2a9.webp";